import { Badge, Box, HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionDto, SeV2QuestionStatus } from "../../../../../autogen/bff-api";
import { formatDateTime } from "../../../../../common/components/communication/communicationUtils";
import { TipTap } from "../../../../../common/input/TipTap/TipTap";

export const SupplierQuestionThread = ({ question }: { question: SeV2QuestionDto }) => {
  const { t } = useTranslation();
  return (
    <Box borderWidth="1px" borderColor="smBorder" rounded="lg" overflow="hidden">
      <Box bg="smBackground" p="3">
        <HStack mb="1" spacing="2" align="center" flexWrap="wrap">
          <Text fontSize="xs" fontWeight="semibold" color="smMuted">
            {t("Your question")} · {question.subject}
          </Text>
          {question.status === SeV2QuestionStatus.Published && (
            <Badge colorScheme="green" variant="subtle" textTransform="none" fontWeight="medium">
              {t("Published to all tenderers")}
            </Badge>
          )}
        </HStack>
        <TipTap content={question.content} editable={false} maxHeight="96" />
        <Text fontSize="xs" color="smMuted" mt="1">
          {formatDateTime(question.createdAt)}
        </Text>
      </Box>
      {question.answer ? (
        <Box p="3" borderTopWidth="1px" borderColor="smBorder">
          <Text fontSize="xs" fontWeight="semibold" color="smPrimary" mb="1">
            {t("Answer from the buyer")}
          </Text>
          <TipTap content={question.answer.content} editable={false} maxHeight="96" />
          <Text fontSize="xs" color="smMuted" mt="1">
            {formatDateTime(question.answer.answeredAt)}
          </Text>
        </Box>
      ) : (
        <Box p="3" borderTopWidth="1px" borderColor="smBorder">
          <Text fontSize="sm" fontStyle="italic" color="smMuted">
            {t("Waiting for an answer from the buyer")}
          </Text>
        </Box>
      )}
    </Box>
  );
};
